import { Navigate, useSearchParams } from "react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import { firstAllowedPath, pathWithSearchParams } from "@/lib/navigationPath";
import { useAuthStore } from "@/store/authStore";
import { Permission } from "@/types";
import DevicesPage from "@/pages/devices";

const LEGACY_TAB_PATHS = {
  carousel: "/devices/carousel",
  statistics: "/devices/statistics",
} as const;

const DEVICES_FALLBACKS = [
  { permission: Permission.READERS_READ, path: "/readers" },
  { permission: Permission.CAROUSEL_SLIDES_READ, path: "/devices/carousel" },
  { permission: Permission.STATS_READ, path: "/devices/statistics" },
  {
    permission: Permission.AGENT_VOICE_TRANSCRIPTS_READ,
    path: "/devices/voice-transcripts",
  },
] as const;

export default function DevicesIndexRoute() {
  const [searchParams] = useSearchParams();
  const hasPermission = useAuthStore((s) => s.hasPermission);
  const tab = searchParams.get("tab");

  if (tab === "carousel" || tab === "statistics") {
    return (
      <Navigate
        to={pathWithSearchParams(LEGACY_TAB_PATHS[tab], searchParams, {
          omit: ["tab"],
        })}
        replace
      />
    );
  }

  if (!hasPermission(Permission.DEVICES_READ)) {
    return (
      <Navigate
        to={firstAllowedPath(hasPermission, DEVICES_FALLBACKS)}
        replace
      />
    );
  }

  return (
    <ProtectedRoute requirePermission={Permission.DEVICES_READ}>
      <DevicesPage />
    </ProtectedRoute>
  );
}
